export default __webpack_public_path__ + "static/media/securite.86776aac.svg";